export function aModifyName(_ref, Name) {
  var commit = _ref.commit;
  console.log('action-a');
  return commit('modifyA', Name);
}
export function bModifyName(_ref2, Name) {
  var commit = _ref2.commit;
  console.log('action-b');
  return commit('modifyB', Name);
}